<section class="out-of-scope-category-wrapper">
  <h3 class="title">{{"CATALOG.CATALOG_PAGE.ZERO_RESULT.OUT_OF_SCOPE.CATEGORY_GRID_TITLE" | translate}}: </h3>

  <div class="out-of-scope-category-grid">
    <div
      class="out-of-scope-category-card"
      [lang] = "country"
      *ngFor="let card of cards| slice: 0:limit"
      (click)="goTo(card)"
    >
      <img [src]="card.image" [alt]="card.name" />
      <h4>{{ card.name}}</h4>
    </div>
  </div>

  <div class="expander" *ngIf="isMobile && cards.length > NOT_EXPANDED_LIMIT">
    <button type="button" class="toggle" (click)="toggleExpanded()">
      {{ (isExpanded ? 'SHARED.SHOW_LESS.LABEL' : 'SHARED.SHOW_MORE.LABEL') | translate }}
    </button>

    <mat-icon *ngIf="!isExpanded">expand_more</mat-icon>
    <mat-icon *ngIf="isExpanded">expand_less</mat-icon>
  </div>
</section>
